import { defineComponent as _defineComponent } from 'vue';
import LocaleIcon from '~/components/_next/atoms/AzFlagIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useLocaleSwitcher } from '~/composables/_next/useLocaleSwitcher';
export default /*#__PURE__*/_defineComponent({
  __name: 'StoreLocaleFlagIcon',
  setup: function setup(__props) {
    var _useUiState = useUiState(),
      toggleStoreSwitcherModal = _useUiState.toggleStoreSwitcherModal;
    var _useLocaleSwitcher = useLocaleSwitcher(),
      currentCountry = _useLocaleSwitcher.currentCountry;
    return {
      __sfc: true,
      toggleStoreSwitcherModal: toggleStoreSwitcherModal,
      currentCountry: currentCountry,
      LocaleIcon: LocaleIcon,
      AzButton: AzButton
    };
  }
});